"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      spacing = _useTheme.spacing;

  return {
    root: {
      margin: spacing(2, 0),
      textDecoration: 'none',
      outline: 'none',
      ':focus, :hover': {
        textDecoration: 'underline'
      }
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing }}", function () {
  return [_useTheme2.default];
});

var Link = function Link(props) {
  var classes = useStyles();
  return (0, _core.jsx)(_Typography.default, (0, _extends2.default)({
    css: classes.root,
    color: "primary"
  }, props));
};

__signature__(Link, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Link;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/Link.tsx");
  reactHotLoader.register(Link, "Link", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/Link.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/Link.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Gb290ZXIvTGluay50c3giXSwibmFtZXMiOlsidXNlU3R5bGVzIiwic3BhY2luZyIsInJvb3QiLCJtYXJnaW4iLCJ0ZXh0RGVjb3JhdGlvbiIsIm91dGxpbmUiLCJ1c2VUaGVtZSIsIkxpbmsiLCJwcm9wcyIsImNsYXNzZXMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUE7O0FBRUE7O0FBRUE7Ozs7Ozs7Ozs7Ozs7QUFJQSxJQUFNQSxTQUFTLEdBQUcsU0FBWkEsU0FBWSxHQUFNO0FBQUEsa0JBQ0YseUJBREU7QUFBQSxNQUNkQyxPQURjLGFBQ2RBLE9BRGM7O0FBR3RCLFNBQU87QUFDTEMsSUFBQUEsSUFBSSxFQUFFO0FBQ0pDLE1BQUFBLE1BQU0sRUFBRUYsT0FBTyxDQUFDLENBQUQsRUFBSSxDQUFKLENBRFg7QUFFSkcsTUFBQUEsY0FBYyxFQUFFLE1BRlo7QUFHSkMsTUFBQUEsT0FBTyxFQUFFLE1BSEw7QUFJSix3QkFBa0I7QUFDaEJELFFBQUFBLGNBQWMsRUFBRTtBQURBO0FBSmQ7QUFERCxHQUFQO0FBVUQsQ0FiRDs7Y0FBTUosUztVQUNnQk0sa0I7OztBQWN0QixJQUFNQyxJQUFJLEdBQUcsU0FBUEEsSUFBTyxDQUFzQ0MsS0FBdEMsRUFBOEQ7QUFDekUsTUFBTUMsT0FBTyxHQUFHVCxTQUFTLEVBQXpCO0FBRUEsU0FBTyxlQUFDLG1CQUFEO0FBQVksSUFBQSxHQUFHLEVBQUVTLE9BQU8sQ0FBQ1AsSUFBekI7QUFBK0IsSUFBQSxLQUFLLEVBQUM7QUFBckMsS0FBbURNLEtBQW5ELEVBQVA7QUFDRCxDQUpEOztjQUFNRCxJO1VBQ1lQLFM7OztlQUtITyxJOzs7Ozs7Ozs7Ozs7MEJBckJUUCxTOzBCQWVBTyxJIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHVzZVRoZW1lIGZyb20gJy4uL3N0eWxlcy91c2VUaGVtZSc7XG5pbXBvcnQgeyBHZW5lcmljQ29tcG9uZW50IH0gZnJvbSAnLi4vdHlwZXMvd2l0aC1hcy1wcm9wJztcbmltcG9ydCBUeXBvZ3JhcGh5LCB7IFR5cG9ncmFwaHlQcm9wcyB9IGZyb20gJy4uL1R5cG9ncmFwaHknO1xuXG5leHBvcnQgdHlwZSBMaW5rUHJvcHM8VCBleHRlbmRzIEdlbmVyaWNDb21wb25lbnQgPSAnc3Bhbic+ID0gVHlwb2dyYXBoeVByb3BzPFQ+O1xuXG5jb25zdCB1c2VTdHlsZXMgPSAoKSA9PiB7XG4gIGNvbnN0IHsgc3BhY2luZyB9ID0gdXNlVGhlbWUoKTtcblxuICByZXR1cm4ge1xuICAgIHJvb3Q6IHtcbiAgICAgIG1hcmdpbjogc3BhY2luZygyLCAwKSxcbiAgICAgIHRleHREZWNvcmF0aW9uOiAnbm9uZScsXG4gICAgICBvdXRsaW5lOiAnbm9uZScsXG4gICAgICAnOmZvY3VzLCA6aG92ZXInOiB7XG4gICAgICAgIHRleHREZWNvcmF0aW9uOiAndW5kZXJsaW5lJyxcbiAgICAgIH0sXG4gICAgfSxcbiAgfTtcbn07XG5cbmNvbnN0IExpbmsgPSA8VCBleHRlbmRzIEdlbmVyaWNDb21wb25lbnQgPSAnc3Bhbic+KHByb3BzOiBMaW5rUHJvcHM8VD4pID0+IHtcbiAgY29uc3QgY2xhc3NlcyA9IHVzZVN0eWxlcygpO1xuXG4gIHJldHVybiA8VHlwb2dyYXBoeSBjc3M9e2NsYXNzZXMucm9vdH0gY29sb3I9XCJwcmltYXJ5XCIgey4uLnByb3BzfSAvPjtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IExpbms7XG4iXX0=